import {lazy} from 'react';

export const SpecialistVerificationAsync = lazy(() =>
    import('./SpecialistVerification')
);
